import type { PortalHeader as PortalHeaderData } from './buildPortalViewModel';
import { useState } from 'react';
import { ExpertViewToggle } from './ExpertViewToggle';
import { ShareLinkModal } from './ShareLinkModal';
import { makePortalUrl } from './makePortalUrl';

interface PortalHeaderProps {
  data: PortalHeaderData;
  docId?: string;
}

export function PortalHeader({ data, docId }: PortalHeaderProps) {
  const [showShareModal, setShowShareModal] = useState(false);

  const shareUrl = docId
    ? makePortalUrl(docId, window.location.origin)
    : window.location.href;

  const handleShare = () => {
    setShowShareModal(true);
  };

  const dotClass = `portal-header__dot portal-header__dot--${data.confidenceLevel}`;

  return (
    <>
      <header className="portal-header" role="banner">
        <div className="portal-header__left">
          <h1 className="portal-header__title">{data.propertySummary}</h1>
          <div className="portal-header__confidence">
            <span className={dotClass} aria-hidden="true" />
            <span className="portal-header__confidence-text">{data.confidenceLabel}</span>
          </div>
        </div>
        <div className="portal-header__actions">
          <ExpertViewToggle />
          <button
            className="portal-header__action"
            onClick={handleShare}
            aria-label="Share assessment"
          >
            Share link
          </button>
        </div>
      </header>
      
      {showShareModal && (
        <ShareLinkModal
          url={shareUrl}
          onClose={() => setShowShareModal(false)}
        />
      )}
    </>
  );
}
